<template>
  <div class="navigation-bar">
    <!-- PC表示 -->
    <navigation-menu-for-pc />
    <!-- PC表示 end -->
    <!-- スマホ表示 -->
    <navigation-menu-for-mobile />
    <!-- スマホ表示 end -->
  </div>
</template>

<script>
import NavigationMenuForPc from '@/components/parts/NavigationMenuForPC'
import NavigationMenuForMobile from '@/components/parts/NavigationMenuForMobile'
export default {
  components: {
    NavigationMenuForPc,
    NavigationMenuForMobile,
  },
  computed: {
    memberId() {
      return this.$route.params.id
    },
  },
  watch: {
    async $route() {
      this.fetchNotifications()
    },
  },
  async created() {
    this.fetchNotifications()
  },
  methods: { 
    fetchNotifications() {
      this.$axios.get('/activities/notifications/?limit=1').then(res => {
        const hasNotifications = res.data.results.length > 0
        this.$store.commit('setHasNotifications', hasNotifications)
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .navigation-bar {
    display: none;
  }
}
</style>